<template>
  <formula-form v-model="formula" @update="onUpdate" edit />
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import FormulaForm from "./form/FormulaForm.vue";
export default {
  name: "FormulaDetails",

  components: {
    FormulaForm,
  },

  data() {
    return {
      formula: undefined,
    };
  },

  computed: {
    ...mapGetters("formulas", ["getFormulaById"]),
  },

  methods: {
    ...mapActions("alert", ["success", "error"]),

    onUpdate() {
      this.$router.push("/formula");
    },

    async loadFormula() {
      this.formula = this.getFormulaById(this.$route.params.id);
      if (this.formula == undefined) {
        this.error(this.$t("common.error"));
        this.$router.push("/formula");
        return;
      }
    },
  },

  async created() {
    await this.loadFormula();
  },
};
</script>
